import BasePointManager from "../../../../../../src/managers/BasePointManager";
import { eventBus, EnumEventBus } from "../EventBus";
import { Coord, RedPointRadianInfo } from "../../../../../../src/types/Interface";
import { CIRCLE_RADIUS, INITIAL_RADIANS, INITIAL_INTERSEC_RADIUS } from "../../types/Config";
import { generateChordPoints } from "./helpers/pointerHelpers";
import { EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";


export default class PointManager extends BasePointManager {
	private intersecLA = INITIAL_INTERSEC_RADIUS;
	private intersecLB = INITIAL_INTERSEC_RADIUS;
	private chordAPoints: Coord[];
	private chordBPoints: Coord[];
	private pointCheckList: Boolean[] = [];
	private tags: string[] = [];

	constructor(cCoord: Coord) {
		super(cCoord, CIRCLE_RADIUS, INITIAL_RADIANS)
		this.setCoord();
		this.draw();

		this.chordAPoints = generateChordPoints(cCoord, CIRCLE_RADIUS, this.pointRadians[0], this.intersecLA);
		this.chordBPoints = generateChordPoints(cCoord, CIRCLE_RADIUS, this.pointRadians[1], this.intersecLB);
		this.tags = this.getRedPoints().map(p => p.tag);

		eventBus.on(EnumEventBus.setPointChecklist, l => this.pointCheckList = l);
		eventBus.on(EnumEventBus.moveCircumPoint, (v: number) => this.handleMoveCircumPoints(v));
		eventBus.on(EnumEventBus.moveChordA, (v: number) => this.handleMoveChordA(v));
		eventBus.on(EnumEventBus.moveChordB, (v: number) => this.handleMoveChordB(v));
		this.rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.resetChordsPoints(true));
		this.rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.resetChordsPoints(false))
	}

	getChordsPoints = () => [this.chordAPoints, this.chordBPoints];
	resetChordsPoints = (started: boolean) => {
		const rads = started ? this.getInitialRadians() : this.pointRadiansBeforeAnim;
		this.chordAPoints = generateChordPoints(this.cCoord, CIRCLE_RADIUS, rads[0], this.intersecLA);
		this.chordBPoints = generateChordPoints(this.cCoord, CIRCLE_RADIUS, rads[1], this.intersecLB);
		if(!started){
			this.setCoord();
		}
	}
	setRadian(pointInfoArr: RedPointRadianInfo[], isSlider?: boolean): void {
		pointInfoArr.forEach(pointInfo => {
			if (pointInfo.pTag == this.tags[0]) {
				this.chordAPoints = generateChordPoints(this.cCoord, CIRCLE_RADIUS, pointInfo.radian, this.intersecLA);
			} else {
				this.chordBPoints = generateChordPoints(this.cCoord, CIRCLE_RADIUS, pointInfo.radian, this.intersecLB);
			}
		})

		this._setRadian(pointInfoArr, isSlider);
	}
	private handleMoveCircumPoints(v: number) {
		const points = this.getRedPoints();
		const radians = this.getRefRadians();
		const generateOffsetRadian = (v: number) => (Math.PI / 300) * v;
		const pointInfoArr = this.pointCheckList
			.map((e, eI) => this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0))
			.map((r, rI) => ({ pTag: points[rI].tag, radian: r }))
			.filter((pointInfo, pII) => pointInfo.radian != radians[pII]);

		this.setRadian(pointInfoArr, true);
	}
	private handleMoveChordA(v: number) {
		this.intersecLA = Math.floor(v * .45 + INITIAL_INTERSEC_RADIUS);
		const pointInfoArr = this.getCurrRedPointInfo(0);
		this.setRadian(pointInfoArr, true);
	}
	private handleMoveChordB(v: number) {
		this.intersecLB = Math.floor(v * .45 + INITIAL_INTERSEC_RADIUS);
		const pointInfoArr = this.getCurrRedPointInfo(1);
		this.setRadian(pointInfoArr, true);
	}
	private getCurrRedPointInfo(index: number) {
		const point = this.RedPointsArr[index];
		const radian = this.pointRadians[index];
		return [{ pTag: point.tag, radian }]
	}
}